import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-42",
  "use": "icon-button_icon-42-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-42\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M5 18v-7a7 7 0 1114 0v7\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.933 7.613l-1.516 3.5h3l-1.484 3.5\" /><path stroke-linecap=\"round\" d=\"M12 1.828v1.334\" /><path d=\"M9 18a3 3 0 006 0\" /><path stroke-linecap=\"round\" d=\"M3 17.5h18\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol